// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__bKBVR","inputDescription":"styles_inputDescription__3VEvJ"};